require('../../modules/es7.array.includes');
module.exports = require('../../modules/$.core').Array.includes;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/array/includes.js
// module id = 1024
// module chunks = 2